
var moment = require('moment');

let DateTimeFormat = (date, maintenantFormat) => {
  const displayDate = moment(date, maintenantFormat ).format('DD/MM/YYYY HH:mm' );
  if ( date === "now" || date  === "Maintenant" || date === "Non-stop" || date === "Without ending date" || date === "Sans date de fin") {
    return date
  } else if (displayDate === 'Invalid date') {
    return '';
  }
  return displayDate;
}

export default DateTimeFormat;



// WEBPACK FOOTER //
// ./src/lib/date/DateTimeFormat.js